import React from 'react';
import { Table, Label, Button } from 'react-bootstrap';
import CenterDetailsLink from '../../common/components/CenterDetailsLink';
import GradeDetailsLink from '../../common/components/GradeDetailsLink';
import { withNamespaces } from 'react-i18next';
import moment from 'moment';
import { PaymentTypes } from './actions';
import utils from '../../common/services/utils';
import ReduxBlockUi from 'react-block-ui/redux';

const View = ({ payment, enableUserTimeZone, onUpdatePaymentOption, blockPaymentOption, unblockPaymentOption, t }) => {
	const { child, lesson, paymentMethod, center, consultationDate, consultationType, workshopSessions, hideUnitPrice, paymentKind } = payment;

	const grade = lesson && lesson.grade;
	const term = lesson && lesson.term;
	const description = () => {
		switch (paymentKind) {
			case PaymentTypes.Lesson: return t(`PaymentTypeEnum_${payment.paymentType}`);
			case PaymentTypes.Workshop: return payment.workshop;
			case PaymentTypes.IndividualConsultation: return t(`IndividualConsultationType_${consultationType}`);
		};
	};

	return <Table responsive>
		<tbody>
			<tr>
				<td>{t('FO_Payment_Id')}</td>
				<td>{payment.id}</td>
			</tr>
			<tr>
				<td>{t('FO_Payment_Child')}</td>
				<td>{child && child.fullName}</td>
			</tr>
			<tr>
				<td>{t('FO_Payment_Center')}</td>
				<td><CenterDetailsLink center={center} /></td>
			</tr>
			{paymentMethod ? <tr>
				<td>{t('FO_Payment_Description')}</td>
				<td>
					{description()}
					<br />
					<Table>
						<thead>
							<tr>
								<th className='tar'>{t(hideUnitPrice ? 'FO_Payment_Item' : 'FO_Payment_Quantity')}</th>
								{!hideUnitPrice && <th className='tar'>{t('FO_Payment_UnitPrice')}</th>}
								<th className='tar'>{t('FO_Payment_Subtotal')}</th>
							</tr>
						</thead>
						<tbody>
							{(!payment.paymentItems || hideUnitPrice) && <tr>
								<td className='tar'>{hideUnitPrice ? t('FO_Payment_Lessons') : payment.quantity}</td>
								{!hideUnitPrice && <td className='tar'>{payment.unitPrice}</td>}
								<td className='tar'>{payment.subtotal}</td>
							</tr>}
							{payment.paymentItems && payment.paymentItems.map((item, index) => <tr key={index}>
								<td className='tar'>{`${item.quantity} x ${item.description}`}</td>
								<td className='tar'>{item.unitPrice}</td>
								<td className='tar'>{item.subtotal}</td>
							</tr>)}
						</tbody>
						<tfoot>
							{payment.discount ?
								<tr>
									<th className='tar' colSpan={hideUnitPrice ? 1 : 2}>{t('FO_Payment_Discount')}</th>
									<td className='tar'>{payment.discount}</td>
								</tr> : null}
							{payment.totalExclTax ?
								<tr>
									<th className='tar' colSpan={hideUnitPrice ? 1 : 2}>{t('FO_Payment_TotalExclTax')}</th>
									<td className='tar'>{payment.totalExclTax}</td>
								</tr> : null}
							{payment.tax ?
								<tr>
									<th className='tar' colSpan={hideUnitPrice ? 1 : 2}>{t('FO_Payment_Tax')}</th>
									<td className='tar'>{payment.tax}</td>
								</tr> : null}
							{payment.paymentMethodFee ?
								<tr>
									<th className='tar' colSpan={hideUnitPrice ? 1 : 2}>{t('FO_Payment_PaymentMethodFee')}</th>
									<td className='tar'>{payment.paymentMethodFee}</td>
								</tr> : null}
							<tr>
								<th className='tar' colSpan={hideUnitPrice ? 1 : 2}>{t('FO_Payment_Total')}</th>
								<td className='tar'>{payment.total}</td>
							</tr>
							<tr>
								<th className='tar' colSpan={hideUnitPrice ? 1 : 2}>{t('FO_Payment_PaidTotal')}</th>
								<td className='tar'>{payment.paidTotal}</td>
							</tr>
							<tr>
								<th className='tar' colSpan={hideUnitPrice ? 1 : 2}>{t('FO_Payment_OutstandingTotal')}</th>
								<td className='tar'>{payment.outstandingTotal}</td>
							</tr>
							{payment.refundedTotal ?
								<tr>
									<th className='tar' colSpan={hideUnitPrice ? 1 : 2}>{t('FO_Payment_Refund')}</th>
									<td className='tar'>{payment.refundedTotal}</td>
								</tr> : null}
						</tfoot>
					</Table>
				</td>
			</tr> : null}
			{workshopSessions && <tr>
				<td>{t('FO_WorkshopPayment_ChildSessions')}</td>
				<td><table>
					<tbody>{workshopSessions.map((session, index) => {
						const sessionStart = enableUserTimeZone ? utils.convertToUserTime(session.start, center) : moment(session.start);
						const sessionEnd = enableUserTimeZone ? utils.convertToUserTime(session.end, center) : moment(session.end);
						return <tr key={index}>
							<td>{`${sessionStart.format('lll')} - ${sessionEnd.format('LT')}`}</td>
							{session.refunded && <td><Label bsStyle="danger" style={{ marginLeft: 20 }}>{`${t('WorkshopSession_Refunded')}`}</Label></td>}
						</tr>
					})}
					</tbody>
				</table></td>
			</tr>}
			<tr>
				<td>{t('FO_Payment_PaymentMethod')}</td>
				<td>{paymentMethod ? (paymentMethod.resourceFriendlyName ? t(paymentMethod.resourceFriendlyName) : paymentMethod.friendlyName) : '-'}</td>
			</tr>
			{payment.paymentCode && <tr>
				<td>{t('FO_Payment_PaymentCode')}</td>
				<td>{payment.paymentCode}</td>
			</tr>}
			<tr>
				<td>{t('FO_Payment_Status')}</td>
				<td>{t(`PaymentStatusType_${payment.status}`)}</td>
			</tr>
			{term &&
				<tr>
					<td>{t('FO_Payment_Term')}</td>
					<td>{term && <span>{term.name}</span>}</td>
				</tr>
			}
			{grade &&
				<tr>
					<td>{t('FO_Payment_Grade')}</td>
					<td><GradeDetailsLink grade={grade} /></td>
				</tr>
			}
			{consultationType &&
				<tr>
					<td>{t('FO_IndividualConsultation_Type')}</td>
					<td>{t(`IndividualConsultationType_${consultationType}`)}</td>
				</tr>
			}
			{consultationDate &&
				<tr>
					<td>{t('FO_IndividualConsultation_Date')}</td>
					<td>{(enableUserTimeZone ? utils.convertToUserTime(consultationDate, center) : moment(consultationDate)).format('lll')}</td>
				</tr>
			}
			<tr>
				<td>{t('FO_Payment_Created')}</td>
				<td>{moment(payment.created).format('lll')}</td>
			</tr>
			{payment.instalments && payment.instalments.length > 0 && <tr>
				<td>{t('FO_Payment_Instalments')}</td>
				<td>
					<Table key={'instalmentTable'}>
						<thead>
							<tr>
								<th className='tar'>{t('FO_Payment_Instalment_ChargeDate')}</th>
								<th className='tar'>{t('FO_Payment_Instalment_Amount')}</th>
								<th className='tar'>{t('FO_Payment_Instalment_Status')}</th>
							</tr>
						</thead>
						<tbody>
							{payment.instalments.sort((a, b) => moment(a) - moment(b)).map(p => <tr key={p.id}>
								<td className='tar'>{moment(p.chargeDate).format('ll')}</td>
								<td className='tar'>{p.amount}</td>
								<td className='tar'>{t(`PaymentStatusType_${p.status.name}`)}</td>
							</tr>)}
						</tbody>
					</Table>
				</td>
			</tr>}
			{payment.canUpdatePaymentOption && <tr>
				<td>{t('FO_Payment_PaymentOption')}</td>
				<td><ReduxBlockUi block={blockPaymentOption} unblock={unblockPaymentOption}>{payment.paymentOption}<a style={{ cursor: 'pointer', marginLeft: 20 }} onClick={() => onUpdatePaymentOption(payment)}>{t('FO_Payment_PaymentOption_Update')}</a></ReduxBlockUi></td>
			</tr>}
			{payment.invoiceUrl ? <tr>
				<td>{t('FO_Payment_Invoice')}</td>
				<td><a target='blank' href={payment.invoiceUrl}>{t('FO_Payment_Invoice')}</a></td>
			</tr> : null}
		</tbody>
	</Table>;
};

export default withNamespaces()(View);